"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M35.5 16.08h-28l9.94-9.94a.967.967 0 0 0 0-1.4l-.7-.72a1.027 1.027 0 0 0-1.42 0L2.48 16.88a1.027 1.027 0 0 0 0 1.42l12.78 13.68a1.027 1.027 0 0 0 1.42 0l.7-.7a1.027 1.027 0 0 0 0-1.42L7.52 19H35.5a.5.5 0 0 0 .5-.5v-1.92a.5.5 0 0 0-.5-.5z" })
);

